import React from "react";
import "./Categories.scss";
import { useParams, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Slider from "../components/Slider";

const BASE_URL = "https://laurephilippe.fr";

const Categories = ({
  categories = [],
  category,
  activeInfoIds,
  setActiveInfoIds,
  setShowInfo,
}) => {
  const { categoryUrl } = useParams();
  const location = useLocation();

  // Find category based on url parameter or use the passed category prop
  const currentCategory =
    category || categories.find((c) => c.fields?.url === categoryUrl);

  if (!currentCategory) return null;

  // Keep projects intact to pass into the Slider so Slider.jsx
  // can natively format them as single or pair depending on whether it has one or two photos.
  const allProjects = [];
  if (currentCategory.fields?.toutLesProjets) {
    allProjects.push(...currentCategory.fields.toutLesProjets);
  }

  return (
    <div className="project-page">
      <Helmet>
        <title>{`${currentCategory.fields?.titre} - Laure Philippe`}</title>
        <link rel="canonical" href={`${BASE_URL}${location.pathname}`} />
      </Helmet>
      <Slider
        photos={allProjects}
        activeInfoIds={activeInfoIds}
        setActiveInfoIds={setActiveInfoIds}
        setShowInfo={setShowInfo}
      />
    </div>
  );
};

export default Categories;
